import { Filters } from 'components/filters/filters.component'
import style from './graphic.module.css'
import { Page } from "components/page/page.component"
import { View } from "components/view/view.component"
import { Text } from 'components/text/text.component'
import { useGetRoomReservationGraphicDataApi } from 'api/graphics.api'
import { Skeleton } from 'components/skeleton'
import { FilterType } from 'model/filter.model'
import { useEffect, useState } from 'react'
import { Graphic } from 'components/graphic/graphic.santander.component'
import { difference, getDaysBefore, getMinutesAfter } from 'utils/date.util'
import { useColorTheme } from 'services/theme.service'

type GraphicPageProps = {
    companyId?: string,
    indicatorId?: string
}

export function GraphicPage({companyId}: GraphicPageProps){
    
    const {COLOR} = useColorTheme()
    const {data, get, loading} = useGetRoomReservationGraphicDataApi()
    const [filter, setFilter] = useState<FilterType | undefined>(undefined)
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined)

    function handleOnFilterChange(filter: FilterType){
        setErrorMessage(undefined)
        setFilter(filter)
    }

    useEffect(()=>{
        if(!companyId) return
        if(!filter?.startDate) return
        if(!filter?.endDate) return
        if(!filter?.rooms) return
        if(difference(filter.endDate, filter.startDate) >= 1) return setErrorMessage('O período máximo é de 1 dia')
        const _filter = {
            rooms: filter.rooms,
            startDate: filter.startDate,
            endDate: filter.endDate
        }
        get(_filter)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[filter, companyId])

    function separateDataByHours(data: any[], hours: number): any[][]{
        // return [data]
        const sortedData = data.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
        const groups: any[][] = []
        let currentGroup: any[] = []
        let groupStartTime: number | null = null

        sortedData.forEach(item => {
            const itemTime = new Date(item.date).getTime()
            if(groupStartTime === null){
                groupStartTime = itemTime
            }
            if(itemTime - groupStartTime <= (hours ?? 12) * 60 * 60 * 1000){
                currentGroup.push(item)
            } else {
                groups.push(currentGroup)
                currentGroup = [item]
                groupStartTime = itemTime
            }
        })
        if(currentGroup.length > 0){
            groups.push(currentGroup)
        }
        return groups
    }

    return <Page menu header title="Gráfico Ocupação de Sala">
        <View className={style.Content}>
            <Filters 
                companyId={companyId} 
                showBuildings
                onlyOneBuilding
                onlyEnableBuildings
                showAreas
                onlyOneArea
                onlyEnableAreas
                showRooms 
                roomIndicatorIds={['room-occupation-status']}
                onlyOneRoom
                onlyEnableRooms
                showStartDate 
                showEndDate 
                dateType='datetime' 
                initialStartDate={getMinutesAfter(getDaysBefore( new Date(), 1), 1)} 
                initialEndDate={new Date()}
                onChange={handleOnFilterChange}
                maxDateInterval={24* 60}// max 24 hours
            />
            {loading 
            ? <Skeleton className={style.GraphicContainer} color='bg3' />
            :<View className={style.GraphicContainer}>
                {!filter?.rooms || filter.rooms.length <= 0
                ? <Text type='h3'>Selecione ao menos uma sala</Text>
                : !filter.startDate || !filter.endDate
                ? <Text type='h3'>Selecione as datas</Text>
                : difference(filter.endDate, filter.startDate) >= 1
                ? <Text type='h3'>Selecione o período máximo de um dia</Text>
                : errorMessage
                ? <Text type='h3'>{errorMessage}</Text>
                : !data || data.length <= 0
                ? <Text type='h3'>Nenhum dado encontrado</Text>
                :<View className={style.GraphicContent}>
                    {separateDataByHours(data, 8).map(
                        (group, index) => <View key={index} className={style.GraphicArea}>
                        <Graphic 
                            labels={group.map(_ => new Date(_.date).toLocaleString('pt-BR', {
                                year: '2-digit',
                                month: '2-digit',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit',
                                // não inclui 'second' para esconder os segundos
                            }))}
                            datasets={[
                                // {
                                //     label: 'Reservada',
                                //     data: data.map(_ => _.reserved? 'ON' : 'OFF'),
                                //     steped: true,
                                //     borderColor: COLOR.blue_primary_color,
                                //     backgroundColor: COLOR.blue_primary_color
                                // },
                                {
                                    label: 'Ocupada',
                                    data: group.map(_ => _.occupied ? 'Ocupada': 'Não Ocupada'),
                                    steped: true,
                                    borderColor: COLOR.blue_primary_color,
                                    backgroundColor: COLOR.blue_primary_color,
                                }
                            ]}
                            type='category'
                            // showLegends
                            legends={[
                                // {
                                //     label: 'Reservada',
                                //     color: COLOR.blue_primary_color
                                // },
                                {
                                    label: 'Ocupada',
                                    color: COLOR.blue_primary_color
                                }
                            ]}
                        />
                    </View>)}
                </View>}
            </View>
            }
        </View>
    </Page>
}